import { MatchesResponse } from '@app/core/api/matching';

/**
 * Matching state interface for NgRx store
 */
export interface MatchingState {
  matches: MatchesResponse | null;
  loading: boolean;
  error: string | null;
}

/**
 * Initial state for matching feature
 */
export const initialMatchingState: MatchingState = {
  matches: null,
  loading: false,
  error: null,
};
